<template>
  <div class="call-fb-card-rating-item-container">
    <span class="label">
      {{ label }}
    </span>
    <div class="value inside-sales">
      <BUserTooltip
        :image-url="mainValueUser.avatarUrl"
        :name="mainValueUser.name"
        :user-id="mainValueUser.id"
        :size="18"
      />
      <div
        :class="`rating-${rating}`"
      >
        <span>{{ mainValue }}</span>
        <span class="unit">{{ unit }}</span>
      </div>
    </div>
    <div class="percentage-bars-container">
      <CallFbPercentageBar
        :percentage="mainValuePercentage"
        :rating="rating"
      />
      <CallFbPercentageBar
        :percentage="subValuePercentage"
        :rating="rating"
      />
      <div class="center-line" />
    </div>
    <div class="value customer">
      <BIcon>
        person
      </BIcon>
      <div>
        {{ `${subValue}${unit}` }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { UserForDisplay } from '@/api/openapi';
import CallFbPercentageBar from './CallFbPercentageBar.vue';
import type { TRating } from './types';

type TProps = {
  label: string;
  unit: string;
  mainValue: number;
  mainValuePercentage: number;
  mainValueUser: UserForDisplay;
  subValue: number;
  subValuePercentage: number;
  rating: TRating;
};

defineProps<TProps>();
</script>

<style lang="scss" scoped>
.call-fb-card-rating-item-container {
  display: flex;
  flex-direction: column;
  gap: $basespace-50;
}

.label {
  color: $textcolor-light;
  padding-bottom: $basespace-50;
}

.value {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: $basespace-50;
  flex-grow: 1;
  line-height: 100%;

  &.inside-sales {
    font-size: $fontsize-300;
    font-weight: 700;
  }

  &.customer {
    color: $textcolor-light;
    font-size: $fontsize-100;
    font-weight: 400;

    :deep(.b-icon) {
      color: $textcolor-light;
    }
  }

  .unit {
    font-size: $fontsize-100;
  }
}

.percentage-bars-container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: $basespace-50;

  .center-line {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    transform: translateX(-50%);
    z-index: 1;
    width: 1px;
    pointer-events: none;

    &::before, &::after {
      content: '';
      position: absolute;
      left: 0;
      height: 4px;
      width: 1px;
      background-color: $bdcolor-base;
    }
    &::before {
      top: -4px;
    }

    &::after {
      bottom: -4px;
    }
  }
}

.rating-fail {
  color: $basecolor-error;
}
.rating-passable {
  color: $basecolor-secondary;
}
.rating-good {
  color: $basecolor-success;
}
</style>
